module.exports = __webpack_public_path__ + "static/media/info.bdc668e2.svg";